<template>
  <section class="">
    <v-card flat class="pa-0 ma-0">
      <v-card-text>
        <v-switch
          :label="` Sms alerts to Sender`"
          v-model="agentFunctionData.is_batch_schedule_enabled"
        ></v-switch>
        <v-switch
          :label="`Sms alerts to Benaficiary `"
          v-model="agentFunctionData.is_allow_multiple_payment_mode"
        ></v-switch>

        <v-switch
          v-model="agentFunctionData.customer_mileage_point"
          :label="`is this a pre-funding parter?`"
        ></v-switch>
        <v-switch
          v-model="agentFunctionData.is_web_hook_enabled"
          :label="`is Webhook Partner?`"
        ></v-switch>
      </v-card-text>
      <v-card class="mt-6 pb-3" v-if="agentFunctionData.is_web_hook_enabled">
        <v-sheet
          class="v-sheet--offset ms-4 pt-1 text-center"
          elevation="2"
          width="170px"
        >
          <p class="font-weight-bold">Webhook url Details</p>
        </v-sheet>
        <v-row class="ms-1 me-1 mt-2" justify="center">
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="labelFontsize my-0"> Customer Webhook url </label>
            <v-text-field
              class="rounded"
              dense
              outlined
              placeholder="Enter Customer Webhook url"
              v-model="agentFunctionData.customer_web_hook_url"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="labelFontsize my-0">Transaction Webhook url</label>
            <v-text-field
              class="rounded"
              dense
              outlined
              placeholder="Enter Transaction Webhook url"
              v-model="agentFunctionData.transaction_web_hook_url"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="labelFontsize my-0"> Webhook token </label>
            <v-text-field
              class="rounded"
              dense
              outlined
              placeholder="Enter Webhook token"
              v-model="agentFunctionData.web_hook_token"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card>
      <span v-if="this.getCompanyDetails && this.getCompanyDetails.created_by">
        <v-row class="ms-5 mt-3 labelFontsize">
          <v-col cols="12" md="4"
            >Created By :{{
              this.getCompanyDetails && this.getCompanyDetails.created_by
                ? this.getCompanyDetails.created_by
                : null
            }}</v-col
          >
          <v-col cols="12" md="4"
            >Created Date :{{
              this.getCompanyDetails && this.getCompanyDetails.created_date
                ? this.getCompanyDetails.created_date
                : null
            }}</v-col
          >
        </v-row>
        <v-row class="ms-5 mt-3 labelFontsize">
          <v-col cols="12" md="4"
            >Updated By :{{
              this.getCompanyDetails && this.getCompanyDetails.modified_by
                ? this.getCompanyDetails.modified_by
                : null
            }}</v-col
          >
          <v-col cols="12" md="4"
            >Updated Date :{{
              this.getCompanyDetails && this.getCompanyDetails.modified_date
                ? this.getCompanyDetails.modified_date
                : null
            }}</v-col
          >
        </v-row>

        <v-row class="ms-5 mt-3 labelFontsize">
          <v-col cols="12" md="4"
            >Approved By :{{
              this.getCompanyDetails && this.getCompanyDetails.approved_by
                ? this.getCompanyDetails.approved_by
                : null
            }}</v-col
          >
          <v-col cols="12" md="4"
            >Approved Date :{{
              this.getCompanyDetails && this.getCompanyDetails.approved_date
                ? this.getCompanyDetails.approved_date
                : null
            }}</v-col
          >
        </v-row>
      </span>
      <v-divider class="mb-0 pa-0"></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed color="primary" small @click="submitAgentDetails">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </section>
</template>

<script>
import alerts from "@/mixins/alerts";
import partnerService from "@/services/partnerService/partnerService.js";
export default {
  mixins: [alerts],
  data() {
    return {
      agentFunctionData: {
        is_batch_schedule_enabled: true,
        is_allow_multiple_payment_mode: true,
        customer_mileage_point: true,
        is_web_hook_enabled: true,
        customer_web_hook_url: null,
        transaction_web_hook_url: null,
        web_hook_token: null,
      },
    };
  },
  props: {
    getCompanyDetails: {
      type: Object,
    },
  },
  mounted() {
    if (this.getCompanyDetails.partner_id) {
      this.getAgentData();
    }
  },

  methods: {
    async submitAgentDetails() {
      const routerDataItem = this.$route.query.partner_id;
      try {
        const responseData = await partnerService.addAgentFunction(
          this.agentFunctionData,
          routerDataItem
        );
        if (responseData.status === 200) {
          this.showAlertSuccess(
            "update Angent Data: " + responseData.data.message
          );
          this.getAgentData();
        } else {
          this.showAlertError("Failed:" + responseData.data.message);
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getAgentData() {
      const routerDataItem = this.$route.query.partner_id;
      try {
        const responseData = await partnerService.getAgentDetails(
          routerDataItem
        );
        if (responseData.status === 200) {
          this.agentFunctionData = responseData.data.data[0];
          console.log(this.agentFunctionData, "Agent Data");
        } else {
          this.showAlertError("Failed:" + responseData.data.message);
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";
.required:after {
  content: " *";
  color: red;
}
</style>
